import update from 'immutability-helper'

export function updateTextBox(node: any, action) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { id, key, value } = action
  return update(node, {
    config: {
      [key]: {
        $set: value,
      },
    },
  })
}
